import React, { useEffect, useRef, useState } from 'react'
import MarketingBudgetHeader from '../MarketingBudgetHeader';
import { Accordion, AccordionDetails, AccordionSummary, AppBar, Backdrop, Button, Card, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, Grid, Icon, IconButton, Input, Paper, Table, TableCell, TableContainer, TableHead, TableRow, TextField, Toolbar, Typography } from '@mui/material';
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';
import BudgetSummaryList from './BudgetSummaryList';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import OAuthService from 'src/app/auth/services/oAuthService';
import SummaryWidget from './SummaryWidget';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.marketingBudget}`;

export default function BudgetSummary() {
    const [tableName, setTableName] = useState('');
    const [data, setData] = useState([])
    const [error, setError] = useState();
    const [selectedYear, setSelectedYear] = useState({
        value: new Date().getFullYear()
    });
    const [loading, setLoading] = useState(false);
    const [backdropOpen, setbackdropOpen] = useState(false);
    const navigate = useNavigate();

    const changeHandler = (data) => {
        loadDate(data, selectedYear)
    };
    const changeYear = (data) => {
        setSelectedYear(data);
        loadDate(data)
    };

    const loadDate = async (year = selectedYear) => {
        try {
            const list = await OAuthService.getList(url + `/marketingSummaryByYear/${year.value}`);
            if(list.data.length === 0) {
                await OAuthService.getList(url + `/valuesForMarketingSummary/${year.value}`);
            }
            const main = list.data;
            setData(main)
            if (!tableName)
                setTableName(main[0]?.categoryName)
        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message);
        }
    }

    const handleUpdate = async (payload, mainIndex, index) => {
        const apiPayload = [...data]
        apiPayload[mainIndex].subCategories[index] = payload
        setData(apiPayload)
    }

    const handleSave = async () => {
        try {
          setLoading(true)
          setbackdropOpen(true);
          await OAuthService.updateData(url + `/editMarketingSummaryByYear`, selectedYear.value, data);
          loadDate()
          setLoading(false);
          setbackdropOpen(false);
          toast.success('Data Updated Successfully')
        } catch (error) {
          setLoading(false);
          setbackdropOpen(false);
          setError(error.message)
          // return true
        }
      }

    useEffect(() => {
        loadDate();
    }, []);

    const handleMarketingBudget = () => {
        navigate(`/marketingBudget`);
      }

    return (
        <>
            <div className="w-full" >
                <MarketingBudgetHeader
                    pageName="Budget Summary"
                    error={error}
                    changeHandler={changeHandler}
                    changeYear={changeYear}
                    selectedYear={selectedYear}
                    handleSave={handleSave}
                    handleMarketingBudget={handleMarketingBudget}
                />
                <div className="flex flex-col md:flex-row sm:p-8">
                    <div className="flex flex-1 flex-col min-w-0">

                        <div className="flex flex-col sm:flex sm:flex-row mb-32" style={{ flexWrap: 'nowrap', overflow: 'auto' }}>
                            {
                                !!data.length && data.map((item) => <div key={item.categoryId} className="widget flex w-full sm:w-1/2 p-16">
                                    <SummaryWidget categoryName={item.categoryName} categoryId={item.categoryId} categoryBudget={item.budgets} setTableName={setTableName} handleChange={() => {
                                        setExpanded(item.subCategories[0].subCategoryId)
                                    }} />
                                </div>)
                            }
                        </div>
                    </div>
                </div>
                <div className="sm:px-8">
                {loading ? <><Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={backdropOpen}
          >
          <CircularProgress color="inherit" />
          <Typography className="pl-16">Please wait while the data loads</Typography>
        </Backdrop></> : ''}
                    {
                        !!data.length && data.map((item, mainIndex) => tableName === item.categoryName && <div className={tableName === item.categoryName ? 'show' : "hide"} key={item.categoryId}>
                            <div className='px-16 pb-16'>
                            <BudgetSummaryList
                                //ref={expanded === `${subItem.subCategoryId}` ? ref : elseRef}
                                handleUpdate={(apiPayload) => handleUpdate(apiPayload, mainIndex)}
                                subItem={item}
                                handleDataChange={(payload) => {
                                    //let data = [...data];
                                    //data[index] = payload;
                                    setData(payload)
                                }}
                            />
                            </div>
                        </div>)
                    }
                </div>
            </div>
        </>
    )
}
